<template>
  <div
    class="flex h-24 pl-20 border-b border-accent-500 shadow-md bg-neutral-0"
  >
    <div class="flex flex-row item-center gap-8">
      <img
        v-if="customerName == 'oost'"
        src="../../../../assets/logo-oost.png"
        class="my-4"
      />
      <img
        v-if="customerName == 'ijsselland'"
        src="../../../../assets/logo.svg"
        class="my-4"
      />
      <div class="flex flex-row gap-6 items-center">
        <router-link
          to="/overview"
          activeClass="hover:underline hover:underline-offset-8"
          class="no-underline font-bold hover:underline hover:underline-offset-8"
          :class="[
            {
              'text-accent-500': customerName == 'ijsselland',
              'text-primary-800': customerName == 'oost',
            },
          ]"
          >Meldkamer planbord</router-link
        >
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useGetCustomer } from "@planbord/queries/planbord-api";
import { watch } from "vue";
import { useCustomerName } from "@planbord/shared/stores";

const { customerName } = useCustomerName();
const { data: dataCustomer } = useGetCustomer();

//watch datacustomer then act
watch(
  () => dataCustomer.value,
  (data) => {
    if (data) {
      useCustomerName().customerName.value = data.toLowerCase();
    }
  }
);
</script>
